"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
_Object$defineProperty(exports, "config", {
  enumerable: true,
  get: function get() {
    return _config.default;
  }
});
_Object$defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _authorization.default;
  }
});
require("@webex/internal-plugin-device");
var _webexCore = require("@webex/webex-core");
var _authorization = _interopRequireDefault(require("./authorization"));
var _config = _interopRequireDefault(require("./config"));
/*!
 * Copyright (c) 2015-2020 Cisco Systems, Inc. See LICENSE file.
 */

var proxies = ['isAuthorizing', 'isAuthenticating'];
(0, _webexCore.registerPlugin)('authorization', _authorization.default, {
  config: _config.default,
  proxies: proxies
});
//# sourceMappingURL=index.js.map
